// Podtemat 3 - prędkość, droga, czas.

import * as SpeedTime from "./podtemat3_predkosc_droga_czas_types/E8SpeedTimeClosedTask";
import * as RouteTimeCompare from "./podtemat3_predkosc_droga_czas_types/E8RouteTimeCompareOpenTask";

export const registry = {
  E8SpeedTimeClosedTask: SpeedTime,
  E8RouteTimeCompareOpenTask: RouteTimeCompare,
};

export function generateTasks(options = {}) {
  return [SpeedTime.generateTask(options), RouteTimeCompare.generateTask(options)];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown task type in 2_6_3: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}